<template>
  <div class="school_list" ref="root">
    <!-- <div class="header">
        <van-icon name="arrow-left" @click="handleBackApp" color="#4E4F51" size="20" data-stat="返回"/>
        <div class="header_title">微课堂</div> 
      </div> -->
    <!-- 小店学堂 -->
    <template>
      <!-- <div class="top_img" v-if="videoBanner" @click="handleBanner(videoBanner.tabUrl)">
        <van-image lazy-load :src="videoBanner.tabPic" />
      </div> -->
      <div class="video_list">
        <template v-if="videoData.videoStatus == 1">
          <van-list v-model:loading="videoData.videoLoading" :finished="videoData.videoFinished" :finished-text="videoData.videoFinishedText" :immediate-check="false" @load="getVideoList">
            <div class="video_item" v-for="(item, index) in videoData.videoList" :key="index" @click="handleVideoDetail(item)">
              <div class="left_img">
                <van-image lazy-load width="125px" height="90px" :src="item.imgUrl2.replace(/http:/, '') || '//i0.ule.com/ulewap/i/290x290x2x.png'" />
              </div>
              <div class="right_side">
                <div class="right_title">{{ item.title }}</div>
                <div class="right_bottom">
                  <div class="left">
                    <div class="icon_number">
                      <i class="icon read"></i>
                      <p>{{ item.pageView }}</p>
                    </div>
                    <div class="icon_number" v-if="item.articleContent == 1">
                      <i class="icon play"></i>
                      <p>{{ item.videoPlayView }}</p>
                    </div>
                  </div>
                  <div class="right_icon">去学习</div>
                </div>
              </div>
            </div>
          </van-list>
        </template>
        <div v-if="videoData.videoStatus == 2">没有小店学堂</div>
      </div>
    </template>
  </div>
</template>
<script>
import { getVideoArticlesByChannelCateApi } from "@/libs/api";
// import { decimalPice, openNewWebView, uleUrl, getCookie, browser } from "../../../lib/common";
export default {
  name:'',
  data() {
    return {
      videoData:{
        videoLoading: false,
        videoFinished: false,
        videoFinishedText: "加载中...",
        videoQuery: {
          pageNum: 1,
          pageSize: 20,
          channel: 200,
          showCategory:20
        },
        videoList: [],
        videoStatus: 0,
        videoBanner: "",
      }
    }
  },
  mounted() {
    this.getVideoList();
    if(this.$browser().ios){
      window.dsBridge.call("setNativeTitle", {
        title: "微课堂",
      });
    }
  },
  methods:{
      getVideoList(){
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: "加载中...",
        });
        getVideoArticlesByChannelCateApi(this.videoData.videoQuery).then((res) => {
          this.videoData.videoLoading = false;
          this.videoData.videoFinished = false;
          this.$toast.clear()
          if (res.returnCode == "0000" && res.data && res.data.result) {
            this.videoData.videoStatus = 1;
            this.videoData.videoList = this.videoData.videoList.concat(res.data.result);
            if (this.videoData.videoQuery.pageSize * this.videoData.videoQuery.pageNum >= res.data.totalRecords) {
              this.videoData.videoFinished = true;
              this.videoData.videoFinishedText = "我已到达底部, 暂无其他数据啦~~";
            } else {
              this.videoData.videoFinished = false;
              this.videoData.videoQuery.pageNum++;
            }
          } else {
            this.videoData.videoStatus = 2;
            this.videoData.videoFinishedText = "";
          }
        });
      },
      handleBanner(link){
        console.log(link);
        openNewWebView(link, false, "");
      },
      handleVideoDetail(item){
        let link = `${item.link}&needShare=true&shareType=14`;
        let appLink = "";
        if (this.$browser().ios) {
          appLink = "objc:ulemobile://action&&WEBVIEW&hasxib|0#key|" + link + "#title|" + item.title + "#isShowTabbar|0#hasnavi|1#isHeadline|1";
          window.location.href = appLink;
          console.log("appLink===", appLink);
        } else if (this.$browser().android) {
          appLink = "ULEMOBILE://action&&ui.MyBusinessWebView##flag::1**load_url::" + link + "**title::" + item.title + "**needLogin::false**needTitle::true**isHeadline::true";
          window.location.href = appLink;
          console.log("appLink===", appLink);
        } else {
          window.location.href = link;
        }
      },
      handleBackApp() {
				if (navigator.userAgent.indexOf("Android") > -1) {
					location.href = "ulemobile://ulePopView";
				} else {
					location.href = "objc:ulemobile://ulePopView";
				}
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/utils.scss";
@import "./schoolList.scss";
</style>
